// AUTO-GENERATED by backend/scripts/gen_flow_i18n.py — do not edit by hand.
// BookingSuccess + ServicePage UI strings (14 languages).
export const FLOW_STRINGS = {
 "de": {
  "bs_title": "Buchung",
  "bs_checking_title": "Zahlung wird geprüft…",
  "bs_checking_sub": "Einen Moment bitte, wir bestätigen Ihre Buchung.",
  "bs_success_title": "Buchung bestätigt!",
  "bs_thanks": "Vielen Dank.",
  "bs_paid_amount": "Ihre Zahlung über {amount} war erfolgreich.",
  "bs_email_confirm": "Sie erhalten eine Bestätigung per E-Mail.",
  "bs_home": "Zur Startseite",
  "bs_timeout_title": "Status ausstehend",
  "bs_failed_title": "Zahlung nicht abgeschlossen",
  "bs_timeout_sub": "Wir konnten den Status nicht sofort bestätigen. Bitte prüfen Sie Ihre E-Mails oder kontaktieren Sie uns.",
  "bs_failed_sub": "Es gab ein Problem mit der Zahlung. Bitte versuchen Sie es erneut.",
  "bs_retry": "Erneut versuchen",
  "bs_call": "Anrufen",
  "sp_eyebrow": "Dienstleistung",
  "sp_badge_fixed": "Festpreis",
  "sp_badge_tracking": "Flugverfolgung 24/7",
  "sp_badge_drivers": "Lizenzierte Fahrer",
  "sp_badge_meet": "Meet & Greet",
  "sp_loading": "Ratgeber wird geladen…",
  "sp_fallback": "Jetzt {service} buchen – Festpreis in Sekunden.",
  "sp_fleet_title": "Unsere Fahrzeugklassen",
  "sp_from": "ab",
  "sp_cta_title": "Bereit für Ihre Fahrt?",
  "sp_cta_sub": "Festpreis in Sekunden – ganz ohne Konto.",
  "sp_cta_btn": "Jetzt buchen"
 },
 "en": {
  "bs_title": "Booking",
  "bs_checking_title": "Verifying payment…",
  "bs_checking_sub": "One moment please, we are confirming your booking.",
  "bs_success_title": "Booking confirmed!",
  "bs_thanks": "Thank you.",
  "bs_paid_amount": "Your payment of {amount} was successful.",
  "bs_email_confirm": "You will receive a confirmation by email.",
  "bs_home": "Back to home",
  "bs_timeout_title": "Status pending",
  "bs_failed_title": "Payment not completed",
  "bs_timeout_sub": "We couldn't confirm the status right away. Please check your emails or contact us.",
  "bs_failed_sub": "There was a problem with the payment. Please try again.",
  "bs_retry": "Try again",
  "bs_call": "Call",
  "sp_eyebrow": "Service",
  "sp_badge_fixed": "Fixed price",
  "sp_badge_tracking": "24/7 flight tracking",
  "sp_badge_drivers": "Licensed drivers",
  "sp_badge_meet": "Meet & Greet",
  "sp_loading": "Loading the guide…",
  "sp_fallback": "Book {service} now – fixed price in seconds.",
  "sp_fleet_title": "Our vehicle classes",
  "sp_from": "from",
  "sp_cta_title": "Ready for your ride?",
  "sp_cta_sub": "Fixed price in seconds – no account needed.",
  "sp_cta_btn": "Book now"
 },
 "fr": {
  "bs_title": "Réservation",
  "bs_checking_title": "Vérification du paiement…",
  "bs_checking_sub": "Un instant s'il vous plaît, nous confirmons votre réservation.",
  "bs_success_title": "Réservation confirmée !",
  "bs_thanks": "Merci.",
  "bs_paid_amount": "Votre paiement de {amount} a été accepté.",
  "bs_email_confirm": "Vous recevrez une confirmation par email.",
  "bs_home": "Retour à l'accueil",
  "bs_timeout_title": "Statut en attente",
  "bs_failed_title": "Paiement non complété",
  "bs_timeout_sub": "Nous n'avons pas pu confirmer le statut immédiatement. Veuillez vérifier vos emails ou nous contacter.",
  "bs_failed_sub": "Un problème est survenu avec le paiement. Veuillez réessayer.",
  "bs_retry": "Réessayer",
  "bs_call": "Appeler",
  "sp_eyebrow": "Service",
  "sp_badge_fixed": "Prix fixe",
  "sp_badge_tracking": "Suivi des vols 24/7",
  "sp_badge_drivers": "Chauffeurs licenciés",
  "sp_badge_meet": "Meet & Greet",
  "sp_loading": "Chargement du guide…",
  "sp_fallback": "Réservez {service} maintenant – prix fixe en quelques secondes.",
  "sp_fleet_title": "Nos classes de véhicules",
  "sp_from": "à partir de",
  "sp_cta_title": "Prêt pour votre trajet ?",
  "sp_cta_sub": "Prix fixe en quelques secondes – aucun compte nécessaire.",
  "sp_cta_btn": "Réserver maintenant"
 },
 "it": {
  "bs_title": "Prenotazione",
  "bs_checking_title": "Verifica pagamento in corso…",
  "bs_checking_sub": "Un momento per favore, stiamo confermando la tua prenotazione.",
  "bs_success_title": "Prenotazione confermata!",
  "bs_thanks": "Grazie.",
  "bs_paid_amount": "Il tuo pagamento di {amount} è andato a buon fine.",
  "bs_email_confirm": "Riceverai una conferma via email.",
  "bs_home": "Torna alla homepage",
  "bs_timeout_title": "Stato in attesa",
  "bs_failed_title": "Pagamento non completato",
  "bs_timeout_sub": "Non siamo riusciti a confermare lo stato immediatamente. Controlla le tue email o contattaci.",
  "bs_failed_sub": "C'è stato un problema con il pagamento. Riprova.",
  "bs_retry": "Riprova",
  "bs_call": "Chiama",
  "sp_eyebrow": "Servizio",
  "sp_badge_fixed": "Prezzo fisso",
  "sp_badge_tracking": "Monitoraggio volo 24/7",
  "sp_badge_drivers": "Autisti autorizzati",
  "sp_badge_meet": "Meet & Greet",
  "sp_loading": "Caricamento della guida…",
  "sp_fallback": "Prenota {service} ora – prezzo fisso in pochi secondi.",
  "sp_fleet_title": "Le nostre classi di veicoli",
  "sp_from": "da",
  "sp_cta_title": "Pronto per il tuo viaggio?",
  "sp_cta_sub": "Prezzo fisso in pochi secondi – nessun account necessario.",
  "sp_cta_btn": "Prenota ora"
 },
 "es": {
  "bs_title": "Reserva",
  "bs_checking_title": "Verificando pago…",
  "bs_checking_sub": "Un momento por favor, estamos confirmando su reserva.",
  "bs_success_title": "¡Reserva confirmada!",
  "bs_thanks": "Gracias.",
  "bs_paid_amount": "Su pago de {amount} fue exitoso.",
  "bs_email_confirm": "Recibirá una confirmación por correo electrónico.",
  "bs_home": "Volver a inicio",
  "bs_timeout_title": "Estado pendiente",
  "bs_failed_title": "Pago no completado",
  "bs_timeout_sub": "No pudimos confirmar el estado de inmediato. Por favor, revise su correo o contáctenos.",
  "bs_failed_sub": "Hubo un problema con el pago. Por favor, inténtelo de nuevo.",
  "bs_retry": "Intentar de nuevo",
  "bs_call": "Llamar",
  "sp_eyebrow": "Servicio",
  "sp_badge_fixed": "Precio fijo",
  "sp_badge_tracking": "Seguimiento de vuelos 24/7",
  "sp_badge_drivers": "Conductores licenciados",
  "sp_badge_meet": "Meet & Greet",
  "sp_loading": "Cargando la guía…",
  "sp_fallback": "Reserve {service} ahora – precio fijo en segundos.",
  "sp_fleet_title": "Nuestras clases de vehículos",
  "sp_from": "desde",
  "sp_cta_title": "¿Listo para su viaje?",
  "sp_cta_sub": "Precio fijo en segundos – no se necesita cuenta.",
  "sp_cta_btn": "Reserve ahora"
 },
 "pt": {
  "bs_title": "Reserva",
  "bs_checking_title": "Verificando pagamento…",
  "bs_checking_sub": "Um momento, por favor, estamos confirmando sua reserva.",
  "bs_success_title": "Reserva confirmada!",
  "bs_thanks": "Obrigado.",
  "bs_paid_amount": "Seu pagamento de {amount} foi bem-sucedido.",
  "bs_email_confirm": "Você receberá uma confirmação por e-mail.",
  "bs_home": "Voltar para a página inicial",
  "bs_timeout_title": "Status pendente",
  "bs_failed_title": "Pagamento não concluído",
  "bs_timeout_sub": "Não conseguimos confirmar o status imediatamente. Por favor, verifique seus e-mails ou entre em contato conosco.",
  "bs_failed_sub": "Houve um problema com o pagamento. Por favor, tente novamente.",
  "bs_retry": "Tente novamente",
  "bs_call": "Ligar",
  "sp_eyebrow": "Serviço",
  "sp_badge_fixed": "Preço fixo",
  "sp_badge_tracking": "Rastreamento de voos 24/7",
  "sp_badge_drivers": "Motoristas licenciados",
  "sp_badge_meet": "Meet & Greet",
  "sp_loading": "Carregando o guia…",
  "sp_fallback": "Reserve {service} agora – preço fixo em segundos.",
  "sp_fleet_title": "Nossas classes de veículos",
  "sp_from": "de",
  "sp_cta_title": "Pronto para sua viagem?",
  "sp_cta_sub": "Preço fixo em segundos – sem necessidade de conta.",
  "sp_cta_btn": "Reserve agora"
 },
 "tr": {
  "bs_title": "Rezervasyon",
  "bs_checking_title": "Ödeme doğrulanıyor…",
  "bs_checking_sub": "Bir dakika lütfen, rezervasyonunuzu onaylıyoruz.",
  "bs_success_title": "Rezervasyon onaylandı!",
  "bs_thanks": "Teşekkür ederiz.",
  "bs_paid_amount": "Ödemeniz {amount} başarıyla gerçekleşti.",
  "bs_email_confirm": "Bir onay e-postası alacaksınız.",
  "bs_home": "Ana sayfaya dön",
  "bs_timeout_title": "Durum beklemede",
  "bs_failed_title": "Ödeme tamamlanmadı",
  "bs_timeout_sub": "Durumu hemen onaylayamadık. Lütfen e-postalarınızı kontrol edin veya bizimle iletişime geçin.",
  "bs_failed_sub": "Ödeme ile ilgili bir sorun oluştu. Lütfen tekrar deneyin.",
  "bs_retry": "Tekrar dene",
  "bs_call": "Ara",
  "sp_eyebrow": "Hizmet",
  "sp_badge_fixed": "Sabit fiyat",
  "sp_badge_tracking": "7/24 uçuş takibi",
  "sp_badge_drivers": "Lisanlı sürücüler",
  "sp_badge_meet": "Meet & Greet",
  "sp_loading": "Rehber yükleniyor…",
  "sp_fallback": "{service} şimdi rezerve edin – sabit fiyat birkaç saniye içinde.",
  "sp_fleet_title": "Araç sınıflarımız",
  "sp_from": "den",
  "sp_cta_title": "Yolculuğunuz için hazır mısınız?",
  "sp_cta_sub": "Sabit fiyat birkaç saniyede – hesap gerekmez.",
  "sp_cta_btn": "Şimdi rezerve et"
 },
 "ru": {
  "bs_title": "Бронирование",
  "bs_checking_title": "Проверка платежа…",
  "bs_checking_sub": "Пожалуйста, подождите, мы подтверждаем вашу бронь.",
  "bs_success_title": "Бронь подтверждена!",
  "bs_thanks": "Спасибо.",
  "bs_paid_amount": "Ваш платеж в размере {amount} прошел успешно.",
  "bs_email_confirm": "Вы получите подтверждение по электронной почте.",
  "bs_home": "Вернуться на главную",
  "bs_timeout_title": "Статус в ожидании",
  "bs_failed_title": "Платеж не завершен",
  "bs_timeout_sub": "Мы не смогли сразу подтвердить статус. Пожалуйста, проверьте свою почту или свяжитесь с нами.",
  "bs_failed_sub": "Произошла ошибка с платежом. Пожалуйста, попробуйте снова.",
  "bs_retry": "Попробуйте еще раз",
  "bs_call": "Позвонить",
  "sp_eyebrow": "Услуга",
  "sp_badge_fixed": "Фиксированная цена",
  "sp_badge_tracking": "Круглосуточное отслеживание рейсов",
  "sp_badge_drivers": "Лицензированные водители",
  "sp_badge_meet": "Meet & Greet",
  "sp_loading": "Загрузка гида…",
  "sp_fallback": "Забронируйте {service} прямо сейчас – фиксированная цена за секунды.",
  "sp_fleet_title": "Наши классы автомобилей",
  "sp_from": "от",
  "sp_cta_title": "Готовы к поездке?",
  "sp_cta_sub": "Фиксированная цена за секунды – без необходимости создавать аккаунт.",
  "sp_cta_btn": "Забронировать сейчас"
 },
 "ar": {
  "bs_title": "الحجز",
  "bs_checking_title": "جاري التحقق من الدفع...",
  "bs_checking_sub": "لحظة من فضلك، نقوم بتأكيد حجزك.",
  "bs_success_title": "تم تأكيد الحجز!",
  "bs_thanks": "شكراً لك.",
  "bs_paid_amount": "تمت معالجة دفعتك البالغة {amount} بنجاح.",
  "bs_email_confirm": "سوف تتلقى تأكيداً عبر البريد الإلكتروني.",
  "bs_home": "العودة إلى الصفحة الرئيسية",
  "bs_timeout_title": "الحالة قيد الانتظار",
  "bs_failed_title": "لم يكتمل الدفع",
  "bs_timeout_sub": "لم نتمكن من تأكيد الحالة على الفور. يرجى التحقق من بريدك الإلكتروني أو الاتصال بنا.",
  "bs_failed_sub": "حدثت مشكلة في الدفع. يرجى المحاولة مرة أخرى.",
  "bs_retry": "حاول مرة أخرى",
  "bs_call": "اتصل",
  "sp_eyebrow": "الخدمة",
  "sp_badge_fixed": "سعر ثابت",
  "sp_badge_tracking": "تتبع الرحلات على مدار الساعة",
  "sp_badge_drivers": "سائقون مرخصون",
  "sp_badge_meet": "Meet & Greet",
  "sp_loading": "جارٍ تحميل الدليل...",
  "sp_fallback": "احجز {service} الآن – سعر ثابت في ثواني.",
  "sp_fleet_title": "فئات مركباتنا",
  "sp_from": "من",
  "sp_cta_title": "هل أنت مستعد لرحلتك؟",
  "sp_cta_sub": "سعر ثابت خلال ثواني – لا حاجة لحساب.",
  "sp_cta_btn": "احجز الآن"
 },
 "fa": {
  "bs_title": "رزرو",
  "bs_checking_title": "در حال تأیید پرداخت…",
  "bs_checking_sub": "لطفاً یک لحظه صبر کنید، ما در حال تأیید رزرو شما هستیم.",
  "bs_success_title": "رزرو تأیید شد!",
  "bs_thanks": "متشکریم.",
  "bs_paid_amount": "پرداخت شما به مبلغ {amount} موفقیت‌آمیز بود.",
  "bs_email_confirm": "شما یک تأییدیه از طریق ایمیل دریافت خواهید کرد.",
  "bs_home": "بازگشت به خانه",
  "bs_timeout_title": "وضعیت معلق",
  "bs_failed_title": "پرداخت تکمیل نشد",
  "bs_timeout_sub": "ما نتوانستیم وضعیت را به‌روز فوری تأیید کنیم. لطفاً ایمیل‌های خود را چک کنید یا با ما تماس بگیرید.",
  "bs_failed_sub": "مشکلی در پرداخت وجود داشت. لطفاً دوباره تلاش کنید.",
  "bs_retry": "دوباره تلاش کنید",
  "bs_call": "تماس",
  "sp_eyebrow": "سرویس",
  "sp_badge_fixed": "قیمت ثابت",
  "sp_badge_tracking": "ردیابی پرواز ۲۴/۷",
  "sp_badge_drivers": "رانندگان دارای مجوز",
  "sp_badge_meet": "Meet & Greet",
  "sp_loading": "در حال بارگذاری راهنما…",
  "sp_fallback": "همین حالا {service} را رزرو کنید – قیمت ثابت در چند ثانیه.",
  "sp_fleet_title": "کلاس‌های خودروی ما",
  "sp_from": "از",
  "sp_cta_title": "آیا آماده حرکت هستید؟",
  "sp_cta_sub": "قیمت ثابت در چند ثانیه – نیازی به حساب نیست.",
  "sp_cta_btn": "همین حالا رزرو کنید"
 },
 "hi": {
  "bs_title": "बुकिंग",
  "bs_checking_title": "भुगतान की पुष्टि हो रही है…",
  "bs_checking_sub": "एक पल रुको, हम आपकी बुकिंग की पुष्टि कर रहे हैं।",
  "bs_success_title": "बुकिंग पुष्टि हो गई!",
  "bs_thanks": "धन्यवाद।",
  "bs_paid_amount": "आपका भुगतान {amount} सफल रहा।",
  "bs_email_confirm": "आपको ईमेल द्वारा एक पुष्टिकरण प्राप्त होगा।",
  "bs_home": "होम पर वापस जाएं",
  "bs_timeout_title": "स्थिति लंबित",
  "bs_failed_title": "भुगतान पूरा नहीं हुआ",
  "bs_timeout_sub": "हम स्थिति की पुष्टि तुरंत नहीं कर सके। कृपया अपने ईमेल चेक करें या हमसे संपर्क करें।",
  "bs_failed_sub": "भुगतान में एक समस्या हुई। कृपया पुनः प्रयास करें।",
  "bs_retry": "फिर से प्रयास करें",
  "bs_call": "कॉल करें",
  "sp_eyebrow": "सेवा",
  "sp_badge_fixed": "फिक्स्ड प्राइस",
  "sp_badge_tracking": "24/7 फ्लाइट ट्रैकिंग",
  "sp_badge_drivers": "लाइसेंस प्राप्त ड्राइवर",
  "sp_badge_meet": "Meet & Greet",
  "sp_loading": "गाइड लोड हो रहा है…",
  "sp_fallback": "अब {service} बुक करें - सेकंडों में फिक्स्ड प्राइस।",
  "sp_fleet_title": "हमारी वाहन श्रेणियाँ",
  "sp_from": "से",
  "sp_cta_title": "क्या आप अपनी सवारी के लिए तैयार हैं?",
  "sp_cta_sub": "सेकंडों में फिक्स्ड प्राइस - कोई खाता आवश्यक नहीं।",
  "sp_cta_btn": "अब बुक करें"
 },
 "zh": {
  "bs_title": "预订",
  "bs_checking_title": "正在验证支付…",
  "bs_checking_sub": "请稍等，我们正在确认您的预订。",
  "bs_success_title": "预订已确认！",
  "bs_thanks": "谢谢您。",
  "bs_paid_amount": "您支付的金额 {amount} 成功。",
  "bs_email_confirm": "您将收到一封确认邮件。",
  "bs_home": "返回主页",
  "bs_timeout_title": "状态待定",
  "bs_failed_title": "支付未完成",
  "bs_timeout_sub": "我们无法立即确认状态。请检查您的电子邮件或与我们联系。",
  "bs_failed_sub": "支付出现问题。请再试一次。",
  "bs_retry": "再试一次",
  "bs_call": "拨打",
  "sp_eyebrow": "服务",
  "sp_badge_fixed": "固定价格",
  "sp_badge_tracking": "24/7 航班跟踪",
  "sp_badge_drivers": "持牌司机",
  "sp_badge_meet": "Meet & Greet",
  "sp_loading": "加载指南…",
  "sp_fallback": "立即预订 {service} – 秒内固定价格。",
  "sp_fleet_title": "我们的车辆类别",
  "sp_from": "从",
  "sp_cta_title": "准备好出发了吗？",
  "sp_cta_sub": "秒内固定价格 – 无需账户。",
  "sp_cta_btn": "立即预订"
 },
 "ko": {
  "bs_title": "예약",
  "bs_checking_title": "결제 확인 중…",
  "bs_checking_sub": "잠시만 기다려 주세요. 예약을 확인하고 있습니다.",
  "bs_success_title": "예약이 확인되었습니다!",
  "bs_thanks": "감사합니다.",
  "bs_paid_amount": "{amount}의 결제가 성공적으로 완료되었습니다.",
  "bs_email_confirm": "확인 이메일을 받게 될 것입니다.",
  "bs_home": "홈으로 돌아가기",
  "bs_timeout_title": "상태 대기 중",
  "bs_failed_title": "결제가 완료되지 않았습니다",
  "bs_timeout_sub": "상태를 즉시 확인할 수 없습니다. 이메일을 확인하거나 저희에게 연락해 주세요.",
  "bs_failed_sub": "결제에 문제가 발생했습니다. 다시 시도해 주십시오.",
  "bs_retry": "다시 시도",
  "bs_call": "전화하기",
  "sp_eyebrow": "서비스",
  "sp_badge_fixed": "고정 가격",
  "sp_badge_tracking": "24/7 비행 추적",
  "sp_badge_drivers": "면허 있는 기사",
  "sp_badge_meet": "Meet & Greet",
  "sp_loading": "가이드를 로딩 중…",
  "sp_fallback": "{service}을(를) 지금 예약하세요 – 몇 초 내에 고정 가격.",
  "sp_fleet_title": "우리 차량 클래스",
  "sp_from": "부터",
  "sp_cta_title": "여행 준비 되셨나요?",
  "sp_cta_sub": "몇 초 내에 고정 가격 – 계정 필요한 없음.",
  "sp_cta_btn": "지금 예약하기"
 },
 "ckb": {
  "bs_title": "رزرو",
  "bs_checking_title": "پشکنینی پارە…",
  "bs_checking_sub": "کەسێکەی پێویستە، بۆ ئەوەی رزڤەکە تایبەتمەندی بکەین.",
  "bs_success_title": "رزرو تایبەتمەند کرا!",
  "bs_thanks": "سوپاس.",
  "bs_paid_amount": "پارەی تۆ لە {amount} سەرکەوتووبوو.",
  "bs_email_confirm": "تۆ ئیمەیڵی پەسندکردن لەگەڵ دەدەیت.",
  "bs_home": "گەڕانەوە بۆ ماوەی سەرەتا",
  "bs_timeout_title": "وەضعیەتی پاراستن",
  "bs_failed_title": "پارەکردن تەواو نەبوو",
  "bs_timeout_sub": "نەتوانین وەضعیەتی پەیوەندیدان فەرمی بکەین. تکایە ئیمەیڵەکانت دابین بکە یان پەیوەندیمان بکە.",
  "bs_failed_sub": "کێشەیەکی ڕوودەوە لەگەڵ پارەکردن. تکایە دابنیشینەوە.",
  "bs_retry": "دابنیشینەوە",
  "bs_call": "وەڵام بدە",
  "sp_eyebrow": "خزمەتی",
  "sp_badge_fixed": "نرخی پەیوەندیدا",
  "sp_badge_tracking": "تراپی شەو و ڕوژ",
  "sp_badge_drivers": "چالاکە نەخشەدارەکان",
  "sp_badge_meet": "Meet & Greet",
  "sp_loading": "بارکردن ڕێنمایی…",
  "sp_fallback": "رزرو بکە {service} ئێستا – نرخێکی پەیوەندیدا لە چەند چەندە.",
  "sp_fleet_title": "کلاسی تۆڕەکان",
  "sp_from": "لە",
  "sp_cta_title": "ئامادەی سەفەرەتی تۆیی؟",
  "sp_cta_sub": "نرخی پەیوەندیدا لە چەند چەندە – ئیشکراوی ئەکاونت پێویست نییە.",
  "sp_cta_btn": "ئێستا رزرو بکە"
 }
};
